<template>
  <div class="row">
    <div class="col-md-12">
      <!-- <h4 class="title">Custom table with pagination</h4> -->
      <p class="category">
       </p>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Spieltage</div>
      </div>
      <div class="card-content row">
        <div class="col-sm-12">
            <button style="margin-right: 5px; margin-bottom: 5px;" v-for="(item, index) in matchdayCount" v-on:click="matchdaySelected(index+1)" v-bind:class="{ 'btn-fill' : selectedMatchday == (index+1), 'btn-default' : selectedMatchday != (index+1) }" type="button" class="btn btn-sm">{{ index + 1 }}</button>
        </div>
        <div class="col-sm-12">
          <p></p>
        </div>
        <div class="col-sm-12">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :formatter="column.formatter"
                             :label="column.label">
            </el-table-column>
            <!--
            <el-table-column
              :min-width="120"
              fixed="right"
              label="Actions">
              <template slot-scope="props">
                <a class="btn btn-simple btn-xs btn-info btn-icon like" @click="handleLike(props.$index, props.row)"><i class="ti-heart"></i></a>
                <a class="btn btn-simple btn-xs btn-warning btn-icon edit" @click="handleEdit(props.$index, props.row)"><i class="ti-pencil-alt"></i></a>
                <a class="btn btn-simple btn-xs btn-danger btn-icon remove"  @click="handleDelete(props.$index, props.row)"><i class="ti-close"></i></a>
              </template>
            </el-table-column>
            -->
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <!-- <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p> -->
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
    computed: {
      matchdayCount () {
        return this.$store.getters.matchdayCount
      },
      selectedMatchday () {
        return this.$store.state.matchday
      },
      tableData () {
        return this.$store.state.rankings
      },
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
        pagination: {
          perPage: 25,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['name', 'email', 'age'],
        tableColumns: [
          {
            prop: 'user_name',
            label: 'Name',
            minWidth: 120
          },
          {
            prop: 'user_email',
            label: 'Email',
            minWidth: 200
          },
          {
            prop: 'betcount',
            label: 'Tipps',
            minWidth: 80,
            formatter: (row, col, cell, index) => this.betsFormatter(row)
          },
          {
            prop: 'points_total',
            label: 'Punkte',
            minWidth: 80,
            formatter: (row, col, cell, index) => this.pointsFormatter(row)
          }
        ]
      }
    },
    created () {
      this.$log.debug('BGPaginatedTables.created')
    },
    beforeCreate () {
      this.$log.debug('BGPaginatedTables.beforeCreate')
    },
    mounted () {
      this.$log.debug('BGPaginatedTables.mounted')
      if (this.$store.state.rankings.length === 0) {
        const b = this.$store.state.betgame
        const c = this.$store.state.competition
        const m = this.$store.state.matchday
        if (b > -1 && c > -1 && m > -1 && this.$store.getters.loggedIn) {
          this.$store.dispatch('fetchRanking', {betgame: b, competition: c, matchday: m})
        }
      }
    },
    methods: {
      pointsFormatter (cell) {
        return '' + cell.points_total
      },
      betsFormatter (cell) {
        return '' + cell.exact + '-' + cell.goaldiff + '-' + cell.tendency + '-' + cell.no_points
      },
      matchdaySelected (matchday) {
        this.$store.dispatch('setMatchday', matchday)
        const b = this.$store.state.betgame
        const c = this.$store.state.competition
        this.$log.debug('matchdaySelected ' + b + ' - ' + c + ' - ' + matchday)
        this.$store.dispatch('fetchRanking', { betgame: b, competition: c, matchday: matchday })
      },
      handleLike (index, row) {
        alert(`Your want to like ${row.name}`)
      },
      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          this.tableData.splice(indexToDelete, 1)
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Tables/BGPaginatedTables.vue